import { Breadcrumb, Button, Col, Form, Input, Row, message } from "antd";
import { HomeOutlined } from "@ant-design/icons";
import { Content } from "antd/es/layout/layout";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { _adr } from "../../../../address";
import { useDealer } from "../../../../tools/api";
import KitRequestModal from "../request/kitRequestModal";

// شماره کیت ۹ رقمیه؛ ولی اسکنر بارکد (گان) یه رشته‌ی ۲۰ رقمی می‌فرسته که رقم یازدهم تا نوزدهمش شماره‌ی واقعی کیته
const extractKitNo = (raw) => {
	const digitsOnly = String(raw || "").replace(/\D/g, "");
	if (digitsOnly.length >= 20) {
		return digitsOnly.slice(10, 19);
	}
	return digitsOnly;
};

const AssignKitDetail = () => {
	const location = useLocation();
	const nav = useNavigate();
	const [messageApi, contextHolder] = message.useMessage();
	const { assignKitToDealer } = useDealer();

	const requestInfo = location?.state || {};
	const requestedQuantity = Number(requestInfo?.requestedQuantity) || 0;

	const [kitValues, setKitValues] = useState([""]);
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [resultModal, setResultModal] = useState(null); // null | { state: "success" | "error", description }

	// تایمرهای debounce به‌ازای هر باکس، تا موقعی که گان کامل ۲۰ رقم رو نفرستاده باکس بعدی زودهنگام اضافه نشه
	const debounceTimers = useRef({});
	useEffect(() => {
		const timers = debounceTimers.current;
		return () => {
			Object.values(timers).forEach(clearTimeout);
		};
	}, []);

	const handleKitChange = (index) => (e) => {
		// رقم‌های خام رو بدون محدود کردن نگه می‌داریم تا توالی ۲۰ رقمی گان قطع نشه
		const rawValue = e.target.value.replace(/\D/g, "");
		const value = extractKitNo(rawValue);

		setKitValues((prev) => {
			const next = [...prev];
			next[index] = value;
			return next;
		});

		clearTimeout(debounceTimers.current[index]);
		debounceTimers.current[index] = setTimeout(() => {
			// فقط بعد از یه مکث کوتاه (یعنی تایپ/اسکن واقعاً تموم شده) تصمیم بگیر باکس بعدی لازمه یا نه
			setKitValues((prev) => {
				const current = prev[index];
				if (index === prev.length - 1 && current?.length === 9 && prev.length < requestedQuantity) {
					return [...prev, ""];
				}
				return prev;
			});
		}, 150);
	};

	const handleSubmit = async () => {
		const kits = kitValues.filter((value) => value?.length === 9).map((value) => ({ kit: Number(value) }));

		if (kits.length === 0) {
			messageApi.open({ type: "error", content: "حداقل یک شماره کیت معتبر (۹ رقمی) وارد کنید." });
			return;
		}

		setIsSubmitting(true);
		try {
			const payload = {
				requestKitId: requestInfo?.requsetId,
				kits,
			};

			const response = await assignKitToDealer(payload);
			if (response) {
				setResultModal({
					state: "success",
					description: response?.Message || "درخواست تخصیص کیت سیم‌کارت شما با موفقیت ثبت شد.",
				});
			} else {
				setResultModal({
					state: "error",
					description: "شماره کیت وارد شده در مخزن توزیع کننده موجود نمی‌باشد.",
				});
			}
		} catch (error) {
			console.error("Failed to assign kits:", error);
			setResultModal({
				state: "error",
				description: "شماره کیت وارد شده در مخزن توزیع کننده موجود نمی‌باشد.",
			});
		}
		setIsSubmitting(false);
	};

	const handleResultModalAction = () => {
		if (resultModal?.state === "success") {
			nav(_adr.Root + _adr.SimLocked.Dealer.Index + _adr.SimLocked.Dealer.AssignKit);
		} else {
			setResultModal(null);
		}
	};

	return (
		<div className="container-main container-cw">
			{contextHolder}
			<div className="holder-top-of-page-content">
				<div className="g-hold-title-of-page">
					<Breadcrumb
						className="breadcrumbs"
						items={[
							{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> },
							{ href: _adr.Root + _adr.SimLocked.Dealer.Index + _adr.SimLocked.Dealer.NewRequest, title: "مدیریت کیت سیم‌کارت" },
							{ href: _adr.Root + _adr.SimLocked.Dealer.Index + _adr.SimLocked.Dealer.AssignKit, title: "تخصیص کیت به نماینده" },
						]}
					/>
					<div className="title-page">
						<h3>تخصیص کیت به نماینده</h3>
						<p></p>
					</div>
				</div>
			</div>
			<div className="g-layout-content">
				<Content className="g-layout-main da-container">
					<div className="g-format-page">
						<div className="g-body-format-page">
							<Form layout="vertical">
								<Row gutter={16}>
									<Col xxl={6} xl={8} lg={10} md={12} sm={24} xs={24}>
										<Form.Item className="input-normal" label="تعداد کیت">
											<Input readOnly value={requestInfo?.requestedQuantity} />
										</Form.Item>
									</Col>
								</Row>
								<Row gutter={16}>
									<Col xxl={6} xl={8} lg={10} md={12} sm={24} xs={24}>
										<Form.Item className="input-normal" label="نوع مخزن">
											<Input readOnly value={requestInfo?.poolType} />
										</Form.Item>
									</Col>
								</Row>

								{kitValues.slice(0, requestedQuantity || kitValues.length).map((value, index) => (
									<Row gutter={16} key={index}>
										<Col xxl={6} xl={8} lg={10} md={12} sm={24} xs={24}>
											<Form.Item className="input-normal">
												<Input
													dir="ltr"
													inputMode="numeric"
													maxLength={20}
													placeholder="شماره کیت"
													value={value}
													onChange={handleKitChange(index)}
													addonAfter={index + 1}
												/>
											</Form.Item>
										</Col>
									</Row>
								))}
							</Form>

							<div className="g-footer-format-page">
								<div className="holder-button">
									<Button className="btn-normal btn-aptel" type="primary" danger loading={isSubmitting} onClick={handleSubmit}>
										تخصیص کیت
									</Button>
									<Button
										className="btn-normal"
										type="default"
										onClick={() => nav(_adr.Root + _adr.SimLocked.Dealer.Index + _adr.SimLocked.Dealer.AssignKit)}>
										بازگشت
									</Button>
								</div>
							</div>
						</div>
					</div>
				</Content>
			</div>

			<KitRequestModal
				open={Boolean(resultModal)}
				state={resultModal?.state}
				title="درخواست تخصیص کیت سیم‌کارت"
				description={resultModal?.description}
				buttonText={resultModal?.state === "success" ? "متوجه شدم" : "ویرایش"}
				onClose={() => setResultModal(null)}
				onAction={handleResultModalAction}
			/>
		</div>
	);
};

export default AssignKitDetail;
